














import { defineComponent } from '@vue/composition-api'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import OneTimePassWithNoPlanCompletePane from '@/components/MypageOneTimePassWithNoPlanCompletePage/OneTimePassWithNoPlanCompletePane.vue'

/**
 * ブラウザ版: マイページ: 優待コード: 完了ページ
 */
export default defineComponent({
  name: 'MypageOneTimePassWithNoPlanCompletePage',
  components: {
    OneTimePassWithNoPlanCompletePane,
    SubHeaderSection,
    GlobalNavigationPane,
  },
})
